import i18n from '@locales/i18n';

interface Props {
    name: string;
    nameKo?: string;
    nameEn?: string;
    nameJa?: string;
}

function getGlobalName({
    name, nameKo, nameEn, nameJa,
}:Props): string {
    const { language } = i18n;
    const lang = language.split('-')[0];
    switch (lang) {
    case 'ko':
        return nameKo || name;
    case 'ja':
        return nameJa || nameEn || name;
    case 'en':
        return nameEn || name;
    default:
        return name;
    }
}

export default getGlobalName;
